import {
  useAudioNoteActiveNoteId,
  useAudioNoteAudioSessionId,
  useAudioNoteMeetingCalendarEventId,
} from '@renderer/hooks/audio/use-audio-note-selectors'
import { MEETING_VIEW_ID } from '../../components/meeting/meeting-view-id'

export function useLiveMeetingNotepadKey(): string {
  const calendarEventId = useAudioNoteMeetingCalendarEventId()
  const audioSessionId = useAudioNoteAudioSessionId()
  const audioNoteId = useAudioNoteActiveNoteId()

  return calendarEventId ?? audioSessionId ?? audioNoteId ?? MEETING_VIEW_ID
}
